import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueParticles from 'vue-particles'
import VueResouce from 'vue-resource'
import VueSimpleAlert from "vue-simple-alert"
import VueMatomo from 'vue-matomo'

Vue.config.productionTip = false
Vue.use(VueResouce);
Vue.use(VueParticles);
Vue.use(VueSimpleAlert);
Vue.http.options.root = 'https://api.nathan-rousseau.fr/wp-json';

Vue.use(VueMatomo, {
  host: 'https://matomo.nathan-rousseau.fr/',
  siteId: 1
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window._paq.push(['trackPageView']);